var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 122,
    viewBox: "0 0 186 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6425 49.3007C65.1169 64.5568 43.2331 102.379 30.6262 110.783C17.3472 119.636 61.9747 103.647 76.4652 96.9587C87.2694 91.9721 100.381 90.7431 110.662 85.1352C127.43 75.9892 146.485 63.7649 165.051 59.1234C199.893 50.4129 150.516 40.6555 137.948 36.9315C119.554 31.4817 101.573 38.1978 83.0136 30.3831C67.1378 23.6986 48.6736 20.0235 32.2633 16.3767C24.7827 14.7144 4.08754 5.5869 10.0714 10.374C19.2962 17.7538 25.6232 24.9173 35.3556 31.1107C45.207 37.3798 49.8114 49.3007 63.3683 49.3007",
    stroke: "white",
    strokeWidth: 17,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.0e47813ba495e883c22a79abb70992ad.svg";
export { ForwardRef as ReactComponent };